export default __webpack_public_path__ + "static/media/2425 knife block A top.9ec4f656.png";